export default {
  video: {
    loading: false,
    loaded: false,
    data: [],
  },
};
